import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as CsatActions from './csat.actions';
import { ISatisfactionAnswersList, IState } from './csat.declarations';
import { csatQuery } from './csat.selectors';

@Injectable({ providedIn: 'root' })
export class CsatFacade {

  state$ = this.store.pipe(select(csatQuery.getCsatState))
  questions$ = this.store.pipe(select(csatQuery.getQuestions))
  lastAnswerDate$ = this.store.pipe(select(csatQuery.getLastAnswerDate))

  constructor(private readonly store: Store<IState>) {}

  init() {
    this.store.dispatch(CsatActions.getQuestionsInfo())
  }

  saveUserAnswer(answer: ISatisfactionAnswersList) {
    this.store.dispatch(CsatActions.saveUserAnswer(answer))
  }
}
